import { throttle } from 'lodash-es';

import { isNodeOnFocus } from '../../utils/dom-utils';

import helpers, { READ_MORE_CARD_ID } from './helpers';

const SCROLL_EVENT_TROTTLE_TIME = 0; // Set to zero to prevent skipping the open-card feat when the scroll is too fast

export const init = ($newsYouCanUse) => {
  // DOM Elements
  const $cards = $newsYouCanUse.querySelectorAll('.c-extendable-card');
  const $cardNavigator = $newsYouCanUse.querySelector('.c-card-navigator');
  const $cardNavigatorIndexBtn = $newsYouCanUse.querySelector('.c-card-navigator__index-btn');
  const $cardNavigatorLinks = $newsYouCanUse.querySelectorAll('.c-card-navigator__content-links li');
  const $cardNavigatorUpBtn = $newsYouCanUse.querySelector('.c-card-navigator__arrow-player-up');
  const $cardNavigatorDownBtn = $newsYouCanUse.querySelector('.c-card-navigator__arrow-player-down');
  const $counter = $newsYouCanUse.querySelector('.c-card-navigator__counter');
  const $overlay = $newsYouCanUse.querySelector('.c-overlay');
  const getHeroMediaWrapper = () => document.querySelector('.c-hero__media-wrapper');
  const $playerHero = getHeroMediaWrapper().querySelector('.c-player-card');
  const $readMoreCard = document.querySelector(`#${READ_MORE_CARD_ID}.c-extendable-card--read-more`);

  // Hide link to the same content on "read more" card (if needed)
  if ($readMoreCard) {
    helpers.handleHideReadMoreContent($readMoreCard);
  }

  // Catch possible query params
  const cardIdQueryParam = helpers.getCardIdFromUrl($cards);
  if (cardIdQueryParam) {
    helpers.handleCardIdFromUrl($cards, cardIdQueryParam);
  }

  // When refreshing in place
  if (isNodeOnFocus($newsYouCanUse)) {
    helpers.handleRefreshInPlace({ $cards, $heroMediaWrapper: getHeroMediaWrapper(), $cardNavigator, $playerHero });
  }

  // Init Listeners
  window.addEventListener(
    'scroll',
    throttle(
      () =>
        helpers.handleScrolling({
          $newsYouCanUse,
          $cards,
          $counter,
          $cardNavigator,
          $cardNavigatorUpBtn,
          $cardNavigatorDownBtn,
          $cardNavigatorLinks,
          $overlay,
          $heroMediaWrapper: getHeroMediaWrapper(),
          $playerHero,
          $readMoreCard,
        }),
      SCROLL_EVENT_TROTTLE_TIME
    )
  );
  $cardNavigatorIndexBtn.addEventListener('click', () =>
    helpers.handleClickOnIndexBtn({ $cardNavigator, $cards, $overlay })
  );
  $cardNavigatorUpBtn.addEventListener('click', () => helpers.handleClickUp($cards));
  $cardNavigatorDownBtn.addEventListener('click', () => helpers.handleClickDown($cards));
  $cardNavigatorLinks.forEach(($link) => {
    const cardId = $link.dataset.id;
    $link.addEventListener('click', (event) =>
      helpers.handleClickOnLink({ event, $cards, $overlay, cardId, $cardNavigator })
    );
  });
};
